/*
 * dd-restock-label.js
 * One batch App Proxy fetch of OOS SKU restock dates.
 * Runs for logged-in and logged-out visitors. Do not gate on
 * cfg.loggedIn. collectItems() needs sku from VariantsPage /
 * [data-dd-variant-data]; do not share those pipes with pre-order.
 * Short surfaces: "Back by Aug 23". Trust/status: "Back soon · Back by Aug 23".
 * No date: "Sold out". Date is Sunday of the PO week, then
 * +5 days for warehouse receive → on-site. First paint stays
 * "Sold out" until the batch returns.
 */
(function () {
  'use strict';

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var MONTHS_LONG = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];
  var BATCH = 50;
  var FALLBACK = 'Sold out';
  var ON_SITE_BUFFER_DAYS = 5;

  window._ddRestockDateMap = window._ddRestockDateMap || {};

  function readConfig() {
    var el = document.getElementById('dd-restock-date-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var cfg = readConfig();
  var enabled = !!(cfg && cfg.enabled && cfg.endpoint);

  function customerRestockDate(iso) {
    if (!iso || typeof iso !== 'string') return null;
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
    if (!m) return null;
    var y = parseInt(m[1], 10);
    var mo = parseInt(m[2], 10) - 1;
    var d = parseInt(m[3], 10);
    var date = new Date(y, mo, d);
    if (isNaN(date.getTime())) return null;
    var day = date.getDay();
    var mondayOffset = day === 0 ? -6 : 1 - day;
    var sunday = new Date(y, mo, d + mondayOffset + 6);
    var onSite = new Date(
      sunday.getFullYear(),
      sunday.getMonth(),
      sunday.getDate() + ON_SITE_BUFFER_DAYS
    );
    var today = new Date();
    var todayStart = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    if (onSite < todayStart) return null;
    return onSite;
  }

  function formatMonthDay(date) {
    return MONTHS[date.getMonth()] + ' ' + date.getDate();
  }

  function formatNumericMd(iso) {
    var onSite = customerRestockDate(iso);
    if (!onSite) return '';
    return (onSite.getMonth() + 1) + '/' + onSite.getDate();
  }

  function formatExpectedBackCorner(iso) {
    var md = formatNumericMd(iso);
    return md ? 'BACK BY ' + md : '';
  }

  function formatExpectedBack(iso) {
    var onSite = customerRestockDate(iso);
    if (!onSite) return FALLBACK;
    return 'Back by ' + formatMonthDay(onSite);
  }

  function formatExpectedBackLong(iso) {
    var onSite = customerRestockDate(iso);
    if (!onSite) return FALLBACK;
    return 'Back soon \u00b7 Back by ' + MONTHS_LONG[onSite.getMonth()] + ' ' + onSite.getDate();
  }

  function formatStatusLine(iso) {
    var short = formatExpectedBack(iso);
    if (short === FALLBACK) return FALLBACK;
    return 'Back soon \u00b7 ' + short;
  }

  function isFallbackLabel(label) {
    if (!label) return true;
    var s = String(label);
    return s === FALLBACK || s === 'Awaiting Restock' || s === 'Awaiting restock';
  }

  function isoForVariant(variantOrId) {
    var map = window._ddRestockDateMap || {};
    if (variantOrId && typeof variantOrId === 'object') {
      if (variantOrId.id != null && Object.prototype.hasOwnProperty.call(map, String(variantOrId.id))) {
        return map[String(variantOrId.id)];
      }
      if (variantOrId.sku) {
        var skuKey = 'sku:' + String(variantOrId.sku);
        if (Object.prototype.hasOwnProperty.call(map, skuKey)) return map[skuKey];
      }
      return null;
    }
    if (variantOrId == null || variantOrId === '') return null;
    if (Object.prototype.hasOwnProperty.call(map, String(variantOrId))) {
      return map[String(variantOrId)];
    }
    var asSku = 'sku:' + String(variantOrId);
    if (Object.prototype.hasOwnProperty.call(map, asSku)) return map[asSku];
    return null;
  }

  /*
    One resolver for card, footer, ATC, trust, notify.
    Date is always selected length + texture + this color.
    Never "when is this color back in any length."
    Pass a variant object when the caller already has the combo.
    Pass colorVal for a swatch card. If that combo does not exist,
    return null (do not fall back to another color or length).
  */
  window.ddResolveRestockVariant = function (opts) {
    opts = opts || {};
    if (opts.variant && opts.variant.id != null) return opts.variant;

    var ss = document.querySelector('dd-swatch-selector');
    if (opts.colorVal != null && ss && typeof ss.getMatchingVariantsForColor === 'function') {
      var colorPos = opts.colorPos;
      if (colorPos == null && typeof ss.getColorGroup === 'function' && typeof ss.getPositionForOptionName === 'function') {
        var group = ss.getColorGroup();
        if (group) colorPos = ss.getPositionForOptionName(group.dataset.optionName);
      }
      if (colorPos) {
        var combo = ss.getMatchingVariantsForColor(opts.colorVal, colorPos);
        return (combo && combo[0]) || null;
      }
      return null;
    }
    if (opts.comboVariants && opts.comboVariants.length) {
      return opts.comboVariants[0];
    }
    if (ss && typeof ss.getCurrentVariant === 'function') {
      try {
        var cur = ss.getCurrentVariant();
        if (cur) return cur;
      } catch (e) { /* */ }
    }
    if (ss && typeof ss.findVariantFromSelected === 'function') {
      try {
        var found = ss.findVariantFromSelected();
        if (found) return found;
      } catch (e) { /* */ }
    }
    var input = document.querySelector('product-info input[name="id"]');
    var list = (ss && ss.variantData) || [];
    if (input) {
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(input.value)) return list[i];
      }
    }
    return null;
  };

  window.getRestockLabel = function (variantOrId) {
    if (!enabled) return FALLBACK;
    return formatExpectedBack(isoForVariant(variantOrId));
  };

  window.getRestockBadgeLabel = function (variantOrId) {
    return window.getRestockLabel(variantOrId);
  };

  window.getRestockCornerLabel = function (variantOrId) {
    if (!enabled) return '';
    return formatExpectedBackCorner(isoForVariant(variantOrId));
  };

  window.getRestockNumericLabel = function (variantOrId) {
    if (!enabled) return '';
    return formatNumericMd(isoForVariant(variantOrId));
  };

  window.getRestockHeadline = function (variantOrId) {
    if (!enabled) return FALLBACK;
    var short = formatExpectedBack(isoForVariant(variantOrId));
    return short === FALLBACK ? FALLBACK : 'Back soon';
  };

  window.getRestockStatusLabel = function (variantOrId) {
    if (!enabled) return FALLBACK;
    return formatStatusLine(isoForVariant(variantOrId));
  };

  window.getRestockByEndLabel = function (variantOrId) {
    if (!enabled) return FALLBACK;
    var md = formatNumericMd(isoForVariant(variantOrId));
    return md ? 'Restock expected ' + md : FALLBACK;
  };

  window.getRestockTrustLabel = function (variantOrId) {
    if (!enabled) return FALLBACK;
    return formatExpectedBackLong(isoForVariant(variantOrId));
  };

  window.ddIsRestockFallback = isFallbackLabel;

  function collectItems() {
    var seen = {};
    var items = [];

    function add(v) {
      if (!v || !v.sku || v.id == null) return;
      var id = String(v.id);
      if (seen[id]) return;
      var oos = v.available === false ||
        (v.inventory_management === 'shopify' &&
          typeof v.inventory_quantity === 'number' &&
          v.inventory_quantity <= 0 &&
          v.inventory_policy !== 'continue');
      if (!oos) return;
      seen[id] = true;
      items.push({ sku: String(v.sku), variantId: id });
    }

    var ss = document.querySelector('dd-swatch-selector');
    var list = (ss && ss.variantData) || [];
    for (var i = 0; i < list.length; i++) add(list[i]);

    var jsonEl = document.querySelector('[data-dd-variant-data]');
    if (jsonEl && items.length === 0) {
      try {
        var parsed = JSON.parse(jsonEl.textContent);
        if (Array.isArray(parsed)) {
          for (var j = 0; j < parsed.length; j++) add(parsed[j]);
        }
      } catch (e) { /* noop */ }
    }
    return items;
  }

  function chunk(arr, size) {
    var out = [];
    for (var i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
    return out;
  }

  function applyMap(results, batch) {
    if (!Array.isArray(results)) return;
    for (var i = 0; i < results.length; i++) {
      var row = results[i];
      if (!row || (row.variantId == null && !row.sku)) continue;
      var date = row.soonestIncomingDate || null;
      if (row.variantId != null) window._ddRestockDateMap[String(row.variantId)] = date;
      if (row.sku) window._ddRestockDateMap['sku:' + String(row.sku)] = date;
    }
    var list = batch || [];
    for (var j = 0; j < list.length; j++) {
      var it = list[j];
      if (!it || !it.sku || it.variantId == null) continue;
      if (Object.prototype.hasOwnProperty.call(window._ddRestockDateMap, String(it.variantId))) {
        window._ddRestockDateMap['sku:' + String(it.sku)] = window._ddRestockDateMap[String(it.variantId)];
      }
    }
  }

  function currentVariant() {
    return window.ddResolveRestockVariant();
  }

  function applySurfaces() {
    var variant = currentVariant();
    var label = window.getRestockLabel(variant);
    var trustLabel = typeof window.getRestockTrustLabel === 'function'
      ? window.getRestockTrustLabel(variant)
      : label;

    var trust = document.querySelector('[data-dd-trust-ship-text]');
    if (trust && trust.closest('[data-dd-trust-shipping]')) {
      var row = trust.closest('[data-dd-trust-shipping]');
      var trustLooksRestock = /awaiting restock|sold out|back by|back soon|week of|expected/i.test(trust.textContent || '');
      var trustLooksPreorder = /pre-order/i.test(trust.textContent || '');
      if (!trustLooksPreorder && ((row && row.dataset.shipState === 'restock') || trustLooksRestock)) {
        trust.textContent = trustLabel;
      }
    }

    var stockTxt = document.querySelector('.dd-stock-status__text');
    var isPreorder = !!(variant && window.ddPreorder && typeof window.ddPreorder.get === 'function' && window.ddPreorder.get(variant.id));
    if (stockTxt && variant && variant.available === false && !isPreorder) {
      stockTxt.textContent = typeof window.getRestockStatusLabel === 'function'
        ? window.getRestockStatusLabel(variant)
        : label;
    }

    var soldoutLine = document.querySelector('[data-dd-sf-ship-soldout-label]');
    if (soldoutLine) {
      soldoutLine.textContent = typeof window.getRestockByEndLabel === 'function'
        ? window.getRestockByEndLabel(variant)
        : label;
    }

    document.querySelectorAll('dd-notify-when-available').forEach(function (host) {
      if (typeof host.syncRestockEta === 'function') {
        try { host.syncRestockEta(); } catch (e) { /* */ }
      }
    });

    var ss = document.querySelector('dd-swatch-selector');
    if (ss && typeof ss.applyRestockBadges === 'function') {
      try { ss.applyRestockBadges(); } catch (e) { /* */ }
    }
    var combo = ss && typeof ss.isCurrentComboUnavailable === 'function' && ss.isCurrentComboUnavailable();
    var avail = ss && typeof ss.getAvailableLengthsText === 'function' && ss.getAvailableLengthsText();
    var sticky = document.querySelector('dd-sticky-footer');
    if (sticky && typeof sticky.updateShippingAndCustom === 'function' && variant) {
      try { sticky.updateShippingAndCustom(variant); } catch (e) { /* */ }
    }
    if (sticky && typeof sticky.refreshAtcDateRotate === 'function' && variant) {
      try { sticky.refreshAtcDateRotate(variant); } catch (e) { /* */ }
    }
    if (!combo && !avail) {
      var atcSpan = document.querySelector('.product-form__submit .dd-atc-button__text');
      var submit = document.querySelector('.product-form__submit');
      var atcLabel = typeof window.getRestockHeadline === 'function'
        ? window.getRestockHeadline(variant)
        : label;
      if (atcSpan && submit && submit.disabled) {
        if (typeof window.ddSetPdpAtcLabel === 'function') {
          window.ddSetPdpAtcLabel(atcSpan, atcLabel, /^Available in /i.test(atcLabel));
        } else {
          atcSpan.textContent = atcLabel;
        }
      }
      if (sticky && typeof sticky.syncButtonFromRenderedHtml === 'function' && variant) {
        try { sticky.syncButtonFromRenderedHtml(null, variant); } catch (e) { /* */ }
      }
    }
  }

  window.ddApplyRestockSurfaces = applySurfaces;

  var fetchedKeys = {};

  function priorityIds() {
    var ids = {};
    var ss = document.querySelector('dd-swatch-selector');
    if (!ss) return ids;
    var cards = ss.querySelectorAll('[data-dd-swatch-item].is--sold-out');
    for (var i = 0; i < cards.length; i++) {
      var id = cards[i].dataset.restockVariantId;
      if (id) ids[String(id)] = true;
    }
    var current = currentVariant();
    if (current && current.id != null) ids[String(current.id)] = true;
    return ids;
  }

  function orderItems(items) {
    var want = priorityIds();
    var first = [];
    var rest = [];
    for (var i = 0; i < items.length; i++) {
      if (want[items[i].variantId]) first.push(items[i]);
      else rest.push(items[i]);
    }
    return first.concat(rest);
  }

  function postBatch(batch) {
    return fetch(cfg.endpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: batch })
    }).then(function (res) {
      var ct = (res.headers.get('content-type') || '').toLowerCase();
      if (!res.ok || ct.indexOf('application/json') === -1) return null;
      return res.json();
    }).then(function (data) {
      if (data && data.results) applyMap(data.results, batch);
      applySurfaces();
    }).catch(function () { /* keep Sold out */ });
  }

  function load(force) {
    if (!enabled) return Promise.resolve();
    var items = collectItems().filter(function (it) {
      if (force) return true;
      if (fetchedKeys[it.variantId]) return false;
      fetchedKeys[it.variantId] = true;
      return true;
    });
    if (!items.length) {
      window._ddRestockFetchDone = true;
      applySurfaces();
      return Promise.resolve();
    }

    var ss = document.querySelector('dd-swatch-selector');
    if (ss && typeof ss.applyRestockBadges === 'function') {
      try { ss.applyRestockBadges(); } catch (e) { /* */ }
    }
    items = orderItems(items);
    var batches = chunk(items, BATCH);
    var first = batches[0] ? postBatch(batches[0]) : Promise.resolve();
    return first.then(function () {
      var tail = batches.slice(1).map(function (batch) { return postBatch(batch); });
      return Promise.all(tail);
    }).then(function () {
      window._ddRestockFetchDone = true;
      applySurfaces();
      try {
        document.dispatchEvent(new CustomEvent('dd:restock-map-ready'));
      } catch (e) { /* */ }
    });
  }

  if (!enabled) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { load(false); }, { once: true });
  } else {
    load(false);
  }

  document.addEventListener('dd:variants-full', function () {
    load(false);
  });

  document.addEventListener('variant:change', function () {
    applySurfaces();
  });
})();
